import { render } from "./PerformanceChart.vue?vue&type=template&id=b03586f8&ts=true"
import script from "./PerformanceChart.vue?vue&type=script&lang=ts"
export * from "./PerformanceChart.vue?vue&type=script&lang=ts"

import "./PerformanceChart.vue?vue&type=style&index=0&id=b03586f8&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__